// =================================================
// FUNCTION
// -------------------------------------------------
// Returns only unique values of an array
export const unique = (arr) => {
  return arr.filter((value, index, self) => self.indexOf(value) === index);
};
